$(document).ready(function () {
  let p = $("body").attr("p");
  $(document).on("click", ".print-last-order", function (e) {
    e.preventDefault();
    getlatestOrderToPrint();
  });

  $(document).on(
    "hidden.bs.modal",
    "#cancel-last-order-confirm-model",
    function () {
      $(this).remove();
      $(".modal-backdrop").remove();
    },
  );

  $(document).on("click", "#print-all-order", function (e) {
    e.preventDefault();
    const redirectUrl = $(this).data("route-link");
    document.location.href = redirectUrl;
  });

  $(document).on("click", "#open-cancel-last-order-model", function (e) {
    e.preventDefault();
    const locationId = $(this).attr("data-location-id");
    const orderId = $(this).attr("data-order-id") ?? null;
    $.ajax({
      type: "POST",
      url: "/api/v1/private/order/get-cancel-last-order-model",
      data: {
        location_id: locationId,
        order_id: orderId,
      },
    })
      .done(function (data) {
        if (data && data.html) {
          $("body").append(data.html);
          $("#cancel-last-order-confirm-model").modal("show");
        }

        if (data && data.error) {
          showToast({
            type: "error",
            message: data.error,
            position: "top-right",
          })
          return;
        }
      })
      .fail(function (data) {
        data.responseJSON.error;
        if (data && data.responseJSON && data.responseJSON.error) {
          showToast({
            type: "error",
            message: data.responseJSON.error,
            position: "top-right",
          })
          return;
        }
      });
  });

  $(document).on("click", "#cancel-last-order", function (e) {
    e.preventDefault();
    const orderId = $(this).attr("data-order-id");
    const locationId = $(this).attr("data-location-id");
    $.ajax({
      type: "POST",
      url: "/api/v1/private/order/cancel-last-order",
      data: {
        order_id: orderId,
        location_id: locationId,
      },
    })
      .done(function (data) {
        if (data && data.success) {
          if (data.order && data.orderProducts) {
            const orderReturn = data.order;
            const orderProductsReturn = data.orderProducts;
            const totalPrice = formattedPriceToShow(
              parseFloat(orderReturn.price_ex_vat_total) +
                parseFloat(orderReturn.vat_total),
            );
            const productsWithCount = [];

            orderProductsReturn.forEach((product) => {
              const productDetail = `(${product.quantity})${product.name}`;
              productsWithCount.push(productDetail);
            });
            localStorage.setItem(
              "lastOrderProducts",
              JSON.stringify(productsWithCount),
            );
            localStorage.setItem("lastOrderTotal", totalPrice);
          }
          $("#model-body-message").hide();
          $("#last-order-delete-cancel").hide();
          $("#cancel-last-order").hide();
          $("#cancel-last-order-information").empty();
          $("#cancel-last-order-information").html(`
            <div class="d-flex flex-column align-items-center">
                <div>
                    <i class="material-icons" style="font-size: 3rem; color: green;">check_circle_outline</i>
                </div>
                <div style="color: green; font-size: 1.2rem;">${data.success}</div>
            </div>
            `);

          setTimeout(() => {
            $("#cancel-last-order-confirm-model").modal("hide");
            $(`#order-product-order-id-${orderId}`).fadeOut(500);
            const $menuLinks = $("#menuLinks");
            if ($menuLinks.hasClass("show")) {
              $menuLinks.collapse("hide");
            }

            setLastOrderDetails();
          }, 2000);
        }

        if (data && data.error) {
          $("#model-body-message").hide();
          $("#last-order-delete-cancel").hide();
          $("#cancel-last-order").hide();
          $("#cancel-last-order-information").empty();
          $("#cancel-last-order-information").html(`
            <div class="d-flex flex-column align-items-center">
                <div>
                    <i class="material-icons" style="font-size: 3rem; color: red;">error_outline</i>
                </div>
                <div style="color: red; font-size: 1.2rem; text-align: center;">${data.error}</div>
            </div>
            `);

          setTimeout(() => {
            $("#cancel-last-order-confirm-model").modal("hide");
          }, 5000);
        }
      })
      .fail(function (data) {
        if (data && data.responseJSON.error) {
          $("#model-body-message").hide();
          $("#last-order-delete-cancel").hide();
          $("#cancel-last-order").hide();
          $("#cancel-last-order-information").empty();
          $("#cancel-last-order-information").html(`
            <div class="d-flex flex-column align-items-center">
                <div>
                    <i class="material-icons" style="font-size: 3rem; color: red;">error_outline</i>
                </div>
                <div style="color: red; font-size: 1.2rem; text-align: center;">${data.responseJSON.error}</div>
            </div>
            `);

          setTimeout(() => {
            $("#cancel-last-order-confirm-model").modal("hide");
          }, 5000);
        }
      });
  });
  function setLastOrderDetails() {
    if (
      localStorage.getItem("lastOrderTotal") &&
      localStorage.getItem("lastOrderProducts")
    ) {
      const lastOrderTotal = localStorage.getItem("lastOrderTotal");
      const lastOrderProducts = JSON.parse(
        localStorage.getItem("lastOrderProducts"),
      );
      let orderDetailString = `Siste handel:<strong>${lastOrderTotal} kr</strong>`;
      lastOrderProducts.forEach((product) => {
        orderDetailString += `, ${product}`;
      });
      $(".last-order-detail").html(orderDetailString);
      $(".last-order-detail").removeClass("d-none");
    } else {
      if (!$(".last-order-detail").hasClass("d-none")) {
        $(".last-order-detail").addClass("d-none");
      }
    }
  }
  if (
    p == "organizer_events" ||
    p == "organizer_settings" ||
    p == "organizer_settings_users" ||
    p == "organizer_settings_term" ||
    p == "organizer_events" ||
    p == "organizer_event" ||
    p == "organizer_payout_reports" ||
    p == "organizer_event_sales" ||
    p == "organizer_event_sales_event_ticket_category" ||
    p == "organizer_event_subevent_sales" ||
    p == "organizer_event_subevent_sales_event_ticket_category" ||
    p == "organizer_event_subevent_customers" ||
    p == "organizer_event_subevent_entered_customers" ||
    p == "organizer_event_subevent" ||
    p == "organizer_event_ticket_category" ||
    p == "organizer_event_customers" ||
    p == "organizer_event_entered_customers" ||
    p == "organizer_event_ticket_category" ||
    p == "visit_tracker_location" ||
    p == "visit_tracker_visitor" ||
    p == "events"
  ) {
    $("#organizerAdminMenuLeftToggleButton").click(function () {
      if ($(this).text() == "menu") {
        $(this).text("close");
        removeLeftMenuCollapseCookie();
        openLeftMenu($(this));
      } else {
        $(this).text("menu");
        addLeftMenuCollapseCookie();
        closeLeftMenu($(this));
      }
    });

    function closeLeftMenu(button) {
      $("#admin-content").addClass("collapsed");
      button.removeClass("ml-2");
      button.closest("nav.sidebar").removeClass("col-2");
      button.closest(".sidebar-sticky").find("ul").addClass("d-none");
      $("div#admin-content-frame").removeClass("col-md-10");
      $("div#admin-content-frame").addClass("col-md-12");
    }

    function openLeftMenu(button) {
      $("#admin-content").removeClass("collapsed");
      button.addClass("ml-2");
      button.closest("nav.sidebar").addClass("col-2");
      button.closest(".sidebar-sticky").find("ul").removeClass("d-none");
      $("div#admin-content-frame").removeClass("col-md-12");
      $("div#admin-content-frame").addClass("col-md-10");
    }

    function removeLeftMenuCollapseCookie() {
      let daysForCookieToExpire = 0;
      let cookieExpires = new Date(
        new Date().getTime() + daysForCookieToExpire * 1000 * 60 * 60 * 24,
      );
      document.cookie =
        "collapse_left_menu = ;expires=" + cookieExpires + "; path=/";
    }

    function addLeftMenuCollapseCookie() {
      let daysForCookieToExpire = 1;
      let cookieExpires = new Date(
        new Date().getTime() + daysForCookieToExpire * 1000 * 60 * 60 * 24,
      );
      document.cookie =
        "collapse_left_menu = true;expires=" + cookieExpires + "; path=/";
    }
  }
});
